import { BUYER_AVAILABILITY } from "@/gql/availability";
import { getApolloData } from "@/utils/apollo/get-data";
import { logger } from "@/utils/logger";

export type BuyerAvailability = {
	currentBuyerSlots: {
		startTime: string;
		endTime: string;
	}[];
	otherBuyerSlots: {
		startTime: string;
		endTime: string;
	}[];
	sellerSlots: {
		startTime: string;
		endTime: string;
	}[];
};
export async function getBuyerAvailability(params: {
	buyerId: string;
	unitId?: string;
	projectId?: string;
	isMobile?: boolean; // wrong choice but will be fixed later, if we want buyer's 10km radius slots, we need to pass isMobile as false but not mandatory
}): Promise<BuyerAvailability | { error: string }> {
	const { buyerId, projectId, unitId, isMobile } = params;
	const { data, error } = await getApolloData<{
		buyerUnits: {
			availabilitySlotsV2: BuyerAvailability;
		};
	}>({
		query: BUYER_AVAILABILITY,
		variables: {
			filters: {
				availabilitySlotsV2: {
					buyerId,
					unitId,
					projectId,
					isMobile,
				},
			},
		},
	});

	if (error) {
		logger.error("Failed to fetch buyer availabilities", {
			method: "getBuyerAvailability",
			query: "BUYER_AVAILABILITY (buyerUnits.availabilitySlotsV2)",
			params,
			error,
		});
		return { error: "Failed to fetch buyer availability" };
	}

	if (!data) {
		return { error: "No nearby properties found" };
	}
	const buAvailability = data.buyerUnits.availabilitySlotsV2;
	return buAvailability as unknown as BuyerAvailability;
}
